import React, { useEffect, useState } from 'react';
import useEmblaCarousel from "embla-carousel-react";
import { classIf } from '../../data/utils';
import BannerOdds from './BannerOdds';

const SLIDER_INTERVAL = 8000;

export default function Carousel(props) {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        skipSnaps: false
    });
    const [selected, setSelected] = useState(0);

    useEffect(() => {
        let interval = null;

        function scrollNext() {
            clearInterval(interval);
            interval = setInterval(() => {
                emblaApi.scrollNext();
                setSelected(emblaApi.selectedScrollSnap());
            }, SLIDER_INTERVAL);
        }

        if (emblaApi) {
            scrollNext();
            emblaApi.on('select', () => {
                setSelected(emblaApi.selectedScrollSnap());
                scrollNext();
            });
        }

        return () => {
            clearInterval(interval);
        };
    }, [emblaApi]);

    function openPage(index) {
        emblaApi.scrollTo(index);
        setSelected(emblaApi.selectedScrollSnap());
    }

    const banners = props.banners;
    // const bannersPerPage = banners.length % 2 === 0 ? 2 : 1;
    const bannersPerPage = 1;
    const pages = [[]];
    {
        let current = 0;
        banners?.forEach(banner => {
            if (pages[current].length === bannersPerPage) {
                pages.push([]);
                current++;
            }
            pages[current].push(banner);
        });
    }

    return (
        <div className="c_47" ref={emblaRef}>
            <div className="c_47_1">
                {pages.map((banners, i) =>
                    <div key={i} className="c_47_1_1" data-cols={bannersPerPage}>
                        {banners.map((banner, i) =>
                            <a key={i} href={banner.url} className="c_47_1_1_1">
                                <img src={banner.imageUrl} alt={''} className="c_47_1_1_1_1" />
                                {banner.avvData?.bet != null ?
                                    <BannerOdds data={banner.avvData} />
                                    :
                                    <div className="c_48">
                                        <div className="c_48_1">
                                            <span className="c_48_1_1">{banner.text}</span>
                                        </div>
                                    </div>
                                }
                            </a>
                        )}
                    </div>
                )}
            </div>
            <div className="c_47_2">
                {pages.length > 1 &&
                    <div className="c_47_2_1">
                        {pages.map((pages, i) =>
                            <span key={i} className={"c_47_2_1_1" + classIf(selected === i, 'active')} onClick={() => openPage(i)}></span>
                        )}
                    </div>
                }
            </div>
        </div>
    );
}
